import React, { useState, useEffect } from "react";

const Typewriter = ({ text, delay }) => {
  const [currentText, setCurrentText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // console.log("tex----->", text);

    const timer = setInterval(() => {
      if (currentIndex === text.length || text[currentIndex] == undefined) {
        clearInterval(timer);
        return;
      }

      setCurrentText((prevText) => prevText + text[currentIndex]);
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }, delay);

    return () => {
      clearInterval(timer);
    };
  }, [text, delay, currentIndex]);

  return <span className=" gil-med">{currentText}</span>;
};

export default Typewriter;
